// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1O8s1","rightAdornment":"Header_rightAdornment__3BmMi"};